<template>
    <div class="nav_container" :style="{width: width}" :key="key">
        <router-link v-for="(item, i) in items" :key="'item_'+i"
                     :to="{path: '/settings', hash:item.id}">
            <div  :class="['nav_item', {active: item.id === active}]" @click="$emit('click', item)">
                {{item.name}}
            </div>
        </router-link>

    </div>
</template>

<script>
    export default {
        name: "Navigation",
        data(){
            return{
                key: 0,
            }
        },
        props: {
            items: {
                type: Array,
                default() {
                    return [];
                }
            },
            active: String,
            width:{
                type: String,
                default: '300px'
            }
        },
        watch:{
            items(){
                this.key++;
            }
        }
    }
</script>

<style lang="scss" scoped>
    .nav_container {
        //margin-top: 1.5rem;
        display: flex;
        flex-flow: column;
        > a{
            text-decoration: none;
            color: #394956;
        }
        .nav_item{
            height: 45px;
            background-color: transparent;
            display: flex;
            align-items: center;
            padding: 0 20px;
            cursor: pointer;
            border-left: 5px solid transparent;
            transition: all 0.3s ease-in-out;

            &.active{
                background-color: #fff;
                border-left: 5px solid #00b6ed;
            }

            &:hover:not(.active){
                background-color: rgba(255, 255, 255, 0.35);
            }
        }
    }
</style>